import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';

import { CompliancePageRoutingModule } from './compliance-routing.module';
import { CompliancePage } from './compliance.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, CompliancePageRoutingModule, ComponentsModule],
  declarations: [CompliancePage]
})
export class CompliancePageModule {}
